import {
  faArrowTrendDown,
  faBooks,
  faBullseye,
  faFolderOpen,
  faMicrophone,
  faPenToSquare,
  faTag,
  faWandMagicSparkles,
} from '@fortawesome/pro-duotone-svg-icons'

import { AchievementDescriptor, AchievementId } from '../_types/achievement'

const ACHIEVEMENT_CATALOG: Record<AchievementId, AchievementDescriptor> = {
  onboarded: {
    id: 'onboarded',
    glyph: faWandMagicSparkles,
    title: 'Bootstrapped',
    hint: 'Finish the onboarding wizard.',
    unlockBlurb: 'Welcome to QuickPass. Your profile is good to go.',
  },
  'first-import': {
    id: 'first-import',
    glyph: faTag,
    title: 'First import',
    hint: 'Save a listing by URL.',
    unlockBlurb: "You're officially watching a place. We've got your back.",
  },
  'five-listings': {
    id: 'five-listings',
    glyph: faFolderOpen,
    title: 'Curator',
    hint: 'Track five listings at once.',
    unlockBlurb: 'A proper shortlist. The choosing-is-hard era begins.',
  },
  collector: {
    id: 'collector',
    glyph: faBooks,
    title: 'Power scout',
    hint: 'Track ten listings at once.',
    unlockBlurb: "You're running a one-person rental research firm.",
  },
  'tag-tagger': {
    id: 'tag-tagger',
    glyph: faBullseye,
    title: 'Decision maker',
    hint: 'Tag three listings yes / maybe / no.',
    unlockBlurb: "Cool, you've got opinions. We love that.",
  },
  'note-taker': {
    id: 'note-taker',
    glyph: faPenToSquare,
    title: 'Note taker',
    hint: 'Add a personal note to a listing.',
    unlockBlurb: 'Receipts saved. Your future-self will thank you.',
  },
  'price-drop-spotter': {
    id: 'price-drop-spotter',
    glyph: faArrowTrendDown,
    title: 'Price-drop spotter',
    hint: "See a price drop on a place you're watching.",
    unlockBlurb: "You can smell a deal. Don't let it get away.",
  },
  'dropped-the-mic': {
    id: 'dropped-the-mic',
    glyph: faMicrophone,
    title: 'Dropped the mic',
    hint: 'Catch a 10%+ price drop.',
    unlockBlurb: "That's real money saved. Treat yourself.",
  },
}

const ACHIEVEMENT_ORDER: AchievementId[] = [
  'onboarded',
  'first-import',
  'tag-tagger',
  'note-taker',
  'price-drop-spotter',
  'dropped-the-mic',
  'five-listings',
  'collector',
]

export { ACHIEVEMENT_CATALOG, ACHIEVEMENT_ORDER }
